import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function EnergyPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.energy.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="🌻"
          label={t("pages.onboarding.energy.high")}
          name={t("pages.onboarding.energy.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.energy.high", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="🌾"
          label={t("pages.onboarding.energy.medium")}
          name={t("pages.onboarding.energy.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.energy.medium", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="🥀"
          label={t("pages.onboarding.energy.low")}
          name={t("pages.onboarding.energy.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.energy.low", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
